function useInputs(inputs) {
    return inputs.reduce((prev, curr) => {
        const { name = '', ...rest } = curr;
        prev[name] = rest;
        return prev;
    }, {});
}

export { useInputs };
